import React from "react";
import PropTypes from "prop-types";
import { GoPlus } from "react-icons/go";
import styles from "./addCardButton.module.css";

export default function AddCardButton({ onClick, whitelabel }) {
  return (
    <button
      type="button"
      className={styles.addCardContainer}
      onClick={onClick}
      style={{ color: whitelabel?.theme?.text_primary_color || "#333" }}
    >
      <span className={styles.addIcon}>
        <GoPlus />
      </span>
      <span>Adicionar Cartão de crédito</span>
    </button>
  );
}

AddCardButton.propTypes = {
  onClick: PropTypes.func,
  whitelabel: PropTypes.object,
};
